import React from 'react';

import { Box } from '@chakra-ui/react';
import { customTheme } from 'theme';

// A group header in the entity dropdown and the account picker above it.
export const SourceGroupLabel = ({ label }: { label?: string }) => (
  <Box
    borderBottom="1px solid"
    borderColor={customTheme.colors.gray['200']}
    pb={1}
    fontSize={12}
    color={customTheme.colors.gray['250']}
  >
    {label}
  </Box>
);
